import { cn } from '@/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
  id?: string
}
export const HomeContainer: React.FC<Props> = ({
  children,
  className,
  ...props
}) => {
  return (
    <section className={cn('px-5 lg:px-15', className)} {...props}>
      {' '}
      {children}
    </section>
  )
}
